import type { TNetworkError } from '@/services/errors';

import { BaseService } from '@/services/api';

import type { TErrorLogEntry } from './errorLog.types';

import { toErrorLogDTO } from './errorLog.adapters';

class ErrorLogService extends BaseService {
  protected readonly serviceName = 'errorLogService';

  public recordError(entry: TErrorLogEntry): Promise<undefined | TNetworkError> {
    return this.runVoid(
      this.db
        .from('errors_logger')
        .insert(toErrorLogDTO(entry)),
      'recordError',
    );
  }
}

const errorLogService = new ErrorLogService();

export {
  errorLogService,
};
